<!-- 连续型电子出版物查看 -->

<template>
  <div class="admin-6">
    <div class="headBar linkRoutes">
      <span v-if="querys.pressState == 3">连续型电子出版物查询</span>
      <span v-else>出版连续型电子出版物单位核验</span>
      <i class="el-icon-arrow-right"></i>
      <span>{{ querys.pressName }}</span>
    </div>
    <div class="rejects" v-if="opMsg">
      <div class="rejLine">
        <div class="rejName">状态：</div>
        <div class="rejText">暂缓</div>
      </div>
      <div class="rejLine">
        <div class="rejName">原因：</div>
        <div class="rejText">{{ opMsg }}</div>
      </div>
    </div>
    <MainTabs
      ref="mainTab"
      v-if="wSat == 1"
      :bookName="bookName"
      :pressDat="resDat"
      :defaultYear="this.querys.year1"
      :selYears="selYearRecord"
      @valChangeSearch="valChangeSearch"
      role="admin" />
    <div class="progressTab">
      <div class="headBar">
        <span>审核历史</span>
      </div>
      <el-table :data="tabDat" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center" type="index"> </el-table-column>
        <el-table-column prop="examineName" label="单位" align="center"></el-table-column>
        <el-table-column prop="name" label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row | tansStr("state") }}
          </template>
        </el-table-column>
        <el-table-column prop="examineMessage" label="审核意见" align="center"></el-table-column>
        <el-table-column prop="name" label="批准文号" align="center"></el-table-column>
        <el-table-column prop="checkdAt" width="180" label="操作时间" align="center">
          <template slot-scope="scope">
            <!-- {{scope.row}} -->
            {{ scope.row | tansStr("checkdAt") }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="querys.pressState == 1" class="subArea">
      <div class="headBar">
        <span>审核意见</span>
      </div>
      <div class="radioBx">
        <el-radio-group v-model="params.status">
          <el-radio :label="'1'">通过</el-radio>
          <el-radio :label="'2'">暂缓登记</el-radio>
          <el-radio :label="'5'">注销或拟注销</el-radio>
          <el-radio :label="'4'">撤销</el-radio>
          <!-- <el-radio :label="'3'">退回</el-radio> -->
        </el-radio-group>
        <el-input
          v-if="
            params.status == 1 || params.status == 2 || params.status == 3 || params.status == 5 || params.status == 4
          "
          v-model="params.message"
          type="textarea"
          :rows="5"
          placeholder="请填写意见"></el-input>
      </div>
    </div>
    <div class="subLine">
      <el-button @click="goBack">返回</el-button>
      <el-button v-if="querys.pressState == 1" @click="goBackExamsave" type="warning">退回</el-button>
      <el-button v-if="querys.pressState == 1" type="danger" @click="goExamsave">审 核</el-button>
    </div>
  </div>
</template>

<script>
import MainTabs from "@/views/components/SPEC/ssCommonTabs";
import { getSuccessTabs } from "@/api/pressRole/pressSuccessive";
import {
  goProvinceExam,
  successiveHistory,
  successiveHistoryNew,
  writeReadTimeLxdz,
} from "@/api/provinceRole/provinceRole";
import { adminExam } from "@/api/adminRole/adminRole";
import { getSelYearRecord } from "@/api/pressRole/pressRole";

export default {
  components: {
    MainTabs,
  },
  data() {
    return {
      wSat: 0,
      querys: {
        pressState: 1,
        pressName: "",
        pgsType: "",
        year1: "",
      },
      bookName: "",
      resDat: [{}],
      selYearRecord: [{}],
      tabDat: [],

      opMsg: "",

      params: {
        ids: [],
        status: "1",
        message: "",
      },

      wordsMap: {
        1: "",
        2: "请填写暂缓原因",
        4: "请填写撤销原因",
        5: "请填写注销原因",
      },
    };
  },
  filters: {
    tansStr: function (dat, code) {
      if (code == "state") {
        if (dat.flowName == "省局") {
          let map = {
            1: "通过",
            3: "退回",
            9: "整体上报",

            12: "暂缓",
            13: "注销或拟注销",
            14: "建议撤销",
            21: "暂缓登记",
          };

          return map[dat.status];
        } else if (dat.flowName == "国家新闻出版署") {
          let map = {
            1: "通过",
            2: "暂缓登记",
            3: "退回",
            4: "撤销",
            5: "注销或拟注销",
            10: "整体退回",
            9: "整体发布",
          };

          return map[dat.status];
        } else if (dat.flowName == "登记") {
          let map = {
            1: "待登记",
            2: "已登记",
          };

          return map[dat.status];
        } else {
          return dat.flowName;
        }
      } else if (code == "checkdAt") {
        if (dat["checkdAt"] == "Invalid date" || !dat["checkdAt"]) {
          return "";
        }
        return dat["checkdAt"].substr(0, 16);
      }
    },
  },
  methods: {
    valChangeSearch: function (year) {
      this.getHistoryData(year);
    },
    goBack: function () {
      if (this.querys.pressState == 3) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: "successive_fexam",
          query: {
            pvcId: this.$route.query.pvcId,
          },
        });
      }
    },
    goBackExamsave: function () {
      const msg = "请填写意见！";
      if ((this.params.message || "").length == 0) {
        this.$message.error(msg);
      } else {
        let msg = '确定已查看完毕，并对该单位核验材料批以 "退回" 处理吗？';
        let vm = this;
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.params.ids.push(this.$route.query.examId);
            let paramsNew = { ...this.params, status: "3" };
            const loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            adminExam(paramsNew).then((response) => {
              loading.close();
              let tipCode = response.payload.tipCode;
              let tipMessage = response.payload.tipMessage;
              if (tipCode == "fail") {
                this.$message({
                  message: tipMessage,
                  type: "error",
                });
              } else {
                this.$message({
                  message: tipMessage,
                  type: "success",
                });
                vm.goBack();
              }
            });
          })
          .catch(() => {});
      }
    },
    goExamsave: function () {
      let transArr = ["", "通过", "暂缓登记", "退回", "撤销", "注销或拟注销"];
      let msg = '确定已查看完毕，并对该单位核验材料批以 "' + transArr[this.params.status] + '" 处理吗？';
      let vm = this;
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.params.ids.push(this.$route.query.examId);
          const loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          adminExam(this.params).then((response) => {
            loading.close();
            let tipCode = response.payload.tipCode;
            let tipMessage = response.payload.tipMessage;
            if (tipCode == "fail") {
              this.$message({
                message: tipMessage,
                type: "error",
              });
            } else {
              this.$message({
                message: tipMessage,
                type: "success",
              });
              vm.goBack();
            }
          });
        })
        .catch(() => {});
    },
    gPlist: function () {
      getSuccessTabs({
        publishMaterialId: this.$route.query.listId,
        organizationId: this.$route.query.pressId,
        isSearch: true,
      }).then((response) => {
        let vm = this;
        vm.wSat = 1;
        this.bookName = this.$route.query.bookName;
        if (this.querys.pressState == 1) {
          this.opMsg = response.msg;
        }
        this.resDat.splice(0, 1, response.ppublicationOrganizationMaterialList);
      });
    },
    getHistoryData(year) {
      successiveHistoryNew({ examineId: this.$route.query.examId, year1: year }).then((response) => {
        for (let item of response.fFlowTaskList) {
          if (item.examineName) {
            this.tabDat.push(item);
          }
        }

        // 查找最后的省局审核意见
        let tabDatProvince = (this.tabDat || []).filter((item) => {
          return item.flowName == "国家新闻出版署";
        });
        if (tabDatProvince && tabDatProvince.length > 0) {
          let last = tabDatProvince[tabDatProvince.length - 1];
          this.params.status = last.status == "0" ? "1" : last.status + "";
          this.params.message = last.examineMessage;
        } else {
          this.params.status = "1";
          this.params.message = "";
        }
      });
    },

    writeReadTimeLxdz: function () {
      // console.log('写入审批时间....')
      writeReadTimeLxdz({
        publishMaterialId: this.$route.query.listId,
      }).then((response) => {
        console.debug("writeReadTimeLxdz: ", response);
      });
    },
  },
  created: function () {
    this.querys.pressState = this.$route.query.pressState;
    this.querys.pressName = this.$route.query.pressName;
    this.querys.pressName = this.$route.query.pressName;
    this.querys.year1 = this.$route.query.year1;

    this.gPlist();

    // zym.更新审阅时间
    if (this.$route.query.updateViewDate && this.$route.query.pressState != 2) {
      this.writeReadTimeLxdz();
    }

    getSelYearRecord({
      publishId: this.$route.query.pressId,
      type: 3,
      year1: this.querys.year1,
    }).then((response) => {
      console.log("======", response);
      var arr = [{}];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
        }
      }
      this.selYearRecord = arr;
    });

    // if(this.querys.pressState == 2){
    this.getHistoryData(this.querys.year1);
    // }
  },
};
</script>

<style lang="scss">
.admin-6 {
  padding: 9px;

  .linkRoutes {
    margin-bottom: 9px;

    i {
      vertical-align: middle;
    }
  }

  .rejects {
    border: 1px solid red;
    color: red;
    padding: 15px 0px;
    border-radius: 3px;
    margin-bottom: 9px;

    .rejLine {
      position: relative;
      line-height: 20px;

      .rejName {
        width: 70px;
        font-size: 14px;
        text-align: right;
        float: left;
      }

      .rejText {
        margin-left: 65px;
        font-size: 14px;
      }
    }
  }

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;

    span {
      font-size: 14px;
    }
  }

  .radioBx {
    padding: 30px 90px;
  }

  .el-textarea {
    margin-top: 20px;

    textarea {
      resize: none;
      border-radius: 0px;
    }
  }

  .subLine {
    text-align: center;
    margin: 30px 0px;

    .el-button {
      width: 180px;
      margin-top: 12px;
    }
  }

  .subArea {
    margin-top: 9px;
  }

  .progressTab .headBar {
    margin-top: 9px;
    margin-bottom: 9px;
  }
}
</style>



// WEBPACK FOOTER //
// adminSuccessSkim.vue?eafb7cf8